module.exports = __webpack_public_path__ + "static/media/instanceshop.05b66366.png";